export default __webpack_public_path__ + "locales/sr-Latn-RS/HotkeysPanel.json?hash=d14709f5fa91ed161ca85cbf88b83abf";